import { render, staticRenderFns } from "./CertificateDocument.vue?vue&type=template&id=d197675a&scoped=true"
import script from "./CertificateDocument.vue?vue&type=script&lang=js"
export * from "./CertificateDocument.vue?vue&type=script&lang=js"
import style0 from "./CertificateDocument.vue?vue&type=style&index=0&id=d197675a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d197675a",
  null
  
)

export default component.exports